import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import FormInput from 'components/forms/FormInput';
import SolarIcon from 'components/icons/SolarIcon';
import { LEAD_NAME_MAX_LENGTH } from '@econtractor/types';
import * as apiLead from 'api/apiLeads';

interface LeadTitleProps {
    leadId: number;
    leadName?: string | null;
    onSaved: () => void;
    readOnly?: boolean;
}

const LeadTitle = ({ leadId, leadName, onSaved, readOnly = false }: LeadTitleProps) => {
    const { t } = useTranslation(['Leads', 'common']);
    const { showToast } = useToast();
    const name = String(leadName || '').trim();
    const [showForm, setShowForm] = useState(false);

    const saveName = async (value: string | number) => {
        const next = String(value ?? '').trim().slice(0, LEAD_NAME_MAX_LENGTH);
        if (next === name) return;

        const saved = await apiLead.updateLeadName(leadId, next);
        if (!saved) {
            showToast(t('common:messError'), 'danger');
            return false;
        }

        showToast(t('leadName.saved'), 'success');
        onSaved();
    };

    if (showForm) {
        return (
            <FormInput
                compact
                autoFocus
                title={t('newLead.leadName')}
                showForm={showForm}
                setShowForm={setShowForm}
                defaultValue={name}
                maxLength={LEAD_NAME_MAX_LENGTH}
                callBack={saveName}
            />
        );
    }

    return (
        <div className={name ? 'lead-title-name' : undefined}>
            {name ? <span className="text-body text-break">{name} </span> : null}
            {readOnly ? null : (
            <button
                type="button"
                className={`btn btn-link p-0 fs-10 lh-1 text-primary product-vendor-editable align-baseline${name ? ' lead-title-edit' : ' d-inline'}`}
                onClick={() => setShowForm(true)}
            >
                <SolarIcon name={name ? 'pencil' : 'plus'} className="me-1" style={{ width: '12px', height: '12px' }} />
                {name ? t('common:buttons.change') : t('leadName.add')}
            </button>
            )}
        </div>
    );
};

export default LeadTitle;
